import React, { useMemo } from "react";

import { useQuery } from "@apollo/client";
import { Typography } from "@mui/material";
import pdf from "@react-pdf/renderer";
import { useParams } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { colors } from "@/theme/overrides/colors";

import PDFDocuments, { PDFSectionsProp } from "../RenderPDF/PDFDocuments";

const { StyleSheet, PDFViewer } = pdf;

const useStyles = makeStyles()({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300,
    width: "100%",
    height: "100%",
    backgroundColor: colors.white,
  },
  loadingIndicator: {
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
});

const styles = StyleSheet.create({
  viewer: {
    width: "100%",
    height: "100%",
  },
});

const viewPlanPDFPageQuery = graphql(`
  query ViewProgramPDFPage($id: ID!) {
    program(id: $id) {
      id
      ...PDFDocuments
    }
  }
`);

const ViewPlanPDFPage: React.FC = () => {
  const { classes } = useStyles();
  const { planId } = useParams<{ planId: string }>();
  const { loading, data } = useQuery(viewPlanPDFPageQuery, {
    variables: { id: planId ?? "" },
  });
  const urlParams = new URLSearchParams(window.location.search);
  const sections = useMemo(() => {
    return Array.from(urlParams.entries()).reduce((acc, current) => {
      const [section, enabled] = current;
      if (enabled === "true") acc[section as keyof PDFSectionsProp] = true;
      return acc;
    }, {} as PDFSectionsProp);
  }, []);

  return (
    <div className={classes.container}>
      {loading || data?.program == null ? (
        <div className={classes.loadingIndicator}>
          <Typography variant="h6">Loading document...</Typography>
        </div>
      ) : (
        <PDFViewer style={styles.viewer}>
          <PDFDocuments pdfData={data.program} enabledSections={sections} />
        </PDFViewer>
      )}
    </div>
  );
};

export default ViewPlanPDFPage;
